import Vue from 'vue'
import Vuex from 'vuex'
import Swagger from 'swagger-client'

import coerceValues from './store/CoerceValues.js'
import synchronizeLocation from './store/SynchronizeLocation.js'
import {GeocodeAPI} from "@/util/geocode";
// import _ from "lodash";

Vue.use(Vuex)

async function initSwaggerClient(api, token) {
    return await Swagger({
        url: api,
        authorizations: {
            anonymous: {
                token: {
                    access_token: token
                }
            }
        },
        disableInterfaces: true
    });
}

/**
 * @note This is complete broken since the API provides no URLs with the responses.
 */
export default async ({ api, locationApi, profile, token, }) => {
    window.locationApiClient = new GeocodeAPI(locationApi, token)
    window.client = await initSwaggerClient(api, token)

    window.addEventListener("message", (e) => {
        switch(e.data.method) {
            case 'updateToken':
                window.locationApiClient = new GeocodeAPI(locationApi, e.data.token)
                window.client = initSwaggerClient(api, e.data.token).then(client => window.client = client )
        }
    })

    return new Vuex.Store({
        plugins: [coerceValues, synchronizeLocation],
        state: {
            addedBuildingId: null,
            addedShaftId: null,
            project: {},
            building: {},
            shaft: {},
            definition:  window.client.spec.definitions,
            profile: profile,
            components: {},
            schema: {
                [api]:  window.client.spec
            }
        },
        mutations: {
            set(state, payload) {
                if (state[payload.type][payload.id]) {
                    payload = { ...state[payload.type][payload.id], ...payload }
                }

                Vue.set(state[payload.type], payload.id, payload)
            },
            delete(state, payload) {
                Vue.delete(state[payload.type], payload.id)
            },
            buildingAdded(state, payload) {
                state.addedBuildingId = payload.addedBuildingId
                state.addedShaftId =  payload.addedShaftId
            },
            shaftAdded(state, payload) {
                state.addedShaftId =  payload.addedShaftId
            }
        },
        actions: {
            async initialize({ dispatch, commit }) {
                let result = await  window.client.execute({
                    pathName: '/project',
                    method: 'get',
                    parameters: { 'variables[project]': 'name' }
                })

                if (!result.obj.data.length) {
                    await dispatch('create')
                }

                result.body.data.forEach(data => {
                    data.meta = {
                        api: {
                            path: '/project/{projectId}',
                            parameters: {
                                projectId: data.id
                            }
                        }
                    }
                    commit('set', data)
                });
            },
            async refresh({ commit }, payload) {
                try {
                    const result = await  window.client.execute({
                        pathName: payload.scope.meta.api.path,
                        method: 'get',
                        parameters: {
                            ...payload.scope.meta.api.parameters
                        }
                    })

                    commit('set', result.body.data)
                } catch (error) {
                    console.error('Refresh', payload.scope.type, 'failed with', error)
                }
            },
            async fetch({ commit }, root) {
                if (root.type !== 'project') {
                    throw new Error(`Unknown root scope ${root.type}`)
                }

                let result = await  window.client.execute({
                    pathName: '/project/{projectId}',
                    method: 'get',
                    parameters: { projectId: root.id }
                })

                root = {
                    ...result.body.data,
                    meta: {
                        api: {
                            path: '/project/{projectId}',
                            parameters: { projectId: root.id }
                        }
                    }
                }

                result = await  window.client.execute({
                    pathName: '/project/{projectId}/buildings',
                    method: 'get',
                    parameters: { projectId: root.id, include: 'shafts' }
                })

                result.body.data.map(data => {
                    return {
                        ...data,
                        meta: {
                            api: {
                                path: '/project/{projectId}/buildings/{buildingId}',
                                parameters: { projectId: root.id, buildingId: data.id }
                            }
                        }
                    }
                }).forEach(data => commit('set', data))

                result.body.included.map(data => {
                    const building = data.relationships.building.data
                    return {
                        ...data,
                        meta: {
                            api: {
                                path: '/project/{projectId}/buildings/{buildingId}/shafts/{shaftId}',
                                parameters: { projectId: root.id, buildingId: building.id, shaftId: data.id }
                            }
                        }
                    }
                }).forEach(data => commit('set', data))

                commit('set', root)
            },
            async create({ commit }, parent) {
                const types = {
                    project: 'building',
                    building: 'shaft'
                }

                const type = parent && types[parent.type] || 'project'
                const parameters = parent && parent.meta.api.parameters || {}

                const paths = {
                    post: {
                        project: '/project',
                        building: '/project/{projectId}/buildings',
                        shaft: '/project/{projectId}/buildings/{buildingId}/shafts'
                    },
                    patch: {
                        project: '/project/{projectId}',
                        building: '/project/{projectId}/buildings/{buildingId}',
                        shaft: '/project/{projectId}/buildings/{buildingId}/shafts/{shaftId}'
                    }
                }

                try {
                    const result = await window.client.execute({
                        pathName: paths.post[type],
                        method: 'post',
                        parameters: { ...parameters, [type]: { data: { type } } },
                        requestContentType: 'application/vnd.api+json'
                    })

                    if(type !== 'building') {
                        commit('set', {
                            ...result.body.data,
                            meta: {
                                api: {
                                    path: paths.patch[result.body.data.type],
                                    parameters: {...parameters, [`${result.body.data.type}Id`]: result.body.data.id}
                                }
                            }
                        })
                    }
                    if(type === 'building') {
                        commit('buildingAdded', {addedBuildingId:result.body.data.id, addedShaftId: result.body.data.relationships.shafts.data[result.body.data.relationships.shafts.data.length - 1].id })
                        await this.dispatch('fetch', parent);
                    }
                    if(type === 'shaft') {
                        commit('shaftAdded', {addedShaftId: result.body.data.id});
                    }
                } catch (error) {
                    console.error('Create', type, 'failed with', error)
                }
            },
            async patch({ commit }, { scope, attributes }) {
                await  window.client.execute({
                    pathName: scope.meta.api.path,
                    method: 'patch',
                    parameters: {
                        ...scope.meta.api.parameters, 
                        [scope.type]: { 
                            data: { id: scope.id, type: scope.type, attributes: attributes.reduce(
                                (attributes, attribute) => ({...attributes, [attribute]: scope.attributes[attribute]}), {}
                            ) } 
                        }
                    },
                    requestContentType: 'application/vnd.api+json'
                })

                this.dispatch('refresh', {scope: this.state.project[scope.meta.api.parameters.projectId]});

                commit('set', scope)
            },
            async delete({ commit }, scope) {
                try {
                    await  window.client.execute({
                        pathName: scope.meta.api.path,
                        method: 'delete',
                        parameters: scope.meta.api.parameters,
                        requestContentType: 'application/vnd.api+json'
                    })
                    commit('delete', scope)
                } catch (error) {
                    console.error('Delete', scope.type, 'failed with', error)
                }
            }
        },
        getters: {
            children: (state) => (scope) => {
                let definition = state.definition[scope.type]
                let relationship = definition['x-scope'] && definition['x-scope']['children']

                return definition.properties.relationships.properties[relationship].properties.type.enum.reduce((children, type) => {
                    definition = state.definition[type]
                    relationship = definition['x-scope'] && definition['x-scope']['parent']

                    return children.concat(
                        Object.values(state[type]).filter(child => child.relationships[relationship].data.id === scope.id)
                    )
                }, [])
            },
            scope: (state) => (reference, scope) => {
                const url = new URL(reference, api)
                const segments = url.hash.split('/')

                const type = segments[2]

                const schema = segments.slice(2, 3).reduce(
                    (schema, segment) => schema[segment], state.definition
                )

                while (scope.type !== type) {
                    let parent = state.definition[scope.type]['x-scope'] && state.definition[scope.type]['x-scope']['parent']

                    if (!parent) {
                        scope = undefined
                        break
                    }

                    parent = scope.relationships[parent].data
                    scope = state[parent.type][parent.id]
                }

                return { schema, scope }
            },
            variable: (state) => (reference, scope) => {
                const url = new URL(reference, api)
                const segments = url.hash.split('/')

                const name = segments[segments.length - 1]
                const type = segments[2]
                let context = undefined

                const schema = segments.slice(2, segments.length).reduce(
                    (definition, segment) => definition[segment], state.definition
                )

                while (scope.type !== type) {
                    let parent = state.definition[scope.type]['x-scope'] && state.definition[scope.type]['x-scope']['parent']

                    if (!parent) {
                        scope = undefined
                        break
                    }

                    parent = scope.relationships[parent].data
                    scope = state[parent.type][parent.id]
                }

                if (scope) {
                    context = scope.attributes
                }

                if (context[name] === null && schema.type === 'object' && schema.properties.value
                    && schema.properties.function && schema.properties.calculated) {
                        context[name] = {
                        value: null,
                        function: null,
                        calculated: false
                    }
                }

                return { name, schema, context, scope }
            }
        }
    })
}